import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import './NewFolderModalContentStyle.css'
import { createFolder, fetchFolders } from '../../../../redux/reducers/global/folder/folderSlice'
import { closeModal } from '../../../../redux/reducers/global/modal/modalSlice'

function NewFolderModalContent({ onClose }) {
  const dispatch = useDispatch()

  const [formData, setFormData] = useState({
    label: '',
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    // Dispatch the thunk to create the diagram
    // `formData` will be passed to your createDiagram thunk
    await dispatch(createFolder(formData))
    // Refresh folders to ensure gallery reflects the new item
    dispatch(fetchFolders())
    // Close the modal after creating and refreshing
    dispatch(closeModal())
    onClose();
  }

  return (
    <div className="modal-create modal-create--folder">
      <h2>Crear Nuevo Folder</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <div>Nombre: </div>
          <input
            type="text"
            name="label"
            className="input-nombre"
            value={formData.label}
            onChange={handleInputChange}
            autocomplete="off"
            required
          />
        </label>
        <div className="modal-buttons">
          <button
            type="button"
            onClick={onClose}
            className="btn-cancel"
          >
            Cancelar
          </button>
          <button type="submit" className="btn-submit">
            Crear
          </button>
        </div>
      </form>
    </div>
  )
}

export default NewFolderModalContent
